import type { ReactNode } from "react";
import { Text } from "~/components/text";

export function BisacFilterSection({
  label,
  action,
  testId,
  children,
}: {
  label: string;
  action?: ReactNode;
  testId?: string;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-y-2 py-2" data-testid={testId}>
      <div className="flex items-center justify-between px-6">
        <Text variant="muted">{label}</Text>
        {action}
      </div>
      {children}
    </div>
  );
}
